import React from 'react';

function TotalScore() {
  return (
    <div>
      <h2>Total Skor</h2>
      <p>Ringkasan total skor dari seluruh kategori yang telah diisi.</p>
    </div>
  );
}

export default TotalScore;
